import type { LocationQuery } from "vue-router";

// Четыре постоянные вкладки публичной части (+ admin для ролей). Вкладка
// выводится из первого сегмента пути; всё неизвестное - «Маршруты» (/map).
export type TabKey = "map" | "live" | "safety" | "profile" | "admin";
export const PUBLIC_TABS: TabKey[] = ["map", "live", "safety", "profile"];
const ALL: TabKey[] = [...PUBLIC_TABS, "admin"];

export const tabFromPath = (path: string): TabKey => {
  const seg = path.split("?")[0].split("/")[1] as TabKey;
  return ALL.includes(seg) ? seg : "map";
};

export const pathForTab = (key: TabKey): string => `/${key}`;

// Режим «Список» вкладки «Маршруты»: /map?view=list.
export const isListMode = (query: LocationQuery): boolean => {
  const v = query.view;
  return (Array.isArray(v) ? v[0] : v) === "list";
};
